import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { MainHome, Loading } from './components/molecules/sections';
import { useRestaurantData } from './hooks/useRestaurantData';
import { Header } from "./components/molecules/sections/Header";
import './styles/globals.scss';
import { useUIStore } from "./store";

// --- COMPONENTES AUXILIARES ---
const ErrorDisplay = ({ message }: { message: string }) => (
  <div className="containerGral" style={{ padding: 24, textAlign: 'center' }}>
    <h2 style={{ marginBottom: 8 }}>Menú no disponible</h2>
    <p style={{ marginBottom: 16 }}>{message}</p>
    <button className="btn-retry" onClick={() => window.location.reload()}>
      Reintentar
    </button>
  </div>
);

// --- COMPONENTE DE DISEÑO (LAYOUT) ---
const AppLayout = () => {
  const { loading, config, error } = useRestaurantData();


  if (loading) return <Loading />;
  if (error) return <ErrorDisplay message={error} />;
  if (!config) return <Loading />;


  return (
    <div className="containerGral">
      <Header restaurantName={config.title} />
      <MainHome />

    </div>
  );
};

// --- COMPONENTE RAÍZ ---
function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorDisplay message="Algo salió mal en el sistema." />}>
      <BrowserRouter>
        <Routes>
          {/* Centralizamos la lógica en AppLayout para evitar re-montar el hook de datos */}
          <Route path="/" element={<AppLayout />} />
          <Route path="/delivery" element={<AppLayout />} />
          <Route path="/mesa/:nroMesa" element={<AppLayout />} />

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;